<template lang="pug">
  .no-post.alert.alert-warning( role='alert' )
    | There are no posts found.
</template>

<script lang="js">

export default {
  name: 'no-post',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.no-post {

}
</style>
